// src/pages/produtos/combos/ConjuntoCad.js
// pages/produtos/combos/ConjuntoCad.js
import React, { useState, useEffect } from 'react';
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { IoMdAddCircle } from "react-icons/io";
import ConjuntoSearch from './ConjuntoSearch';
import { Conjunto } from '../../../models/produtos/combos/Conjunto';
import { useConjunto } from '../../../contexts/produtos/combos/ConjuntoContext';
import Input from '../../../components/input/Input';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import { useConjuntoItem } from '../../../contexts/produtos/combos/ConjuntoItemContext';
import ConjuntoItemCad from './ConjuntoItemCad';
import InputCheck from '../../../components/input/InputCheck';
import ModalActions, { ModalActionButton } from '../../../components/modalForm/ModalActions';

const ConjuntoCad = ({ show, onHide }) => {
    const { conjuntos, addConjunto, updateConjunto, deleteConjunto } = useConjunto();
    const [conjunto, setConjunto] = useState(new Conjunto());
    const { conjuntoItens, fetchConjuntoItens, deleteConjuntoItem } = useConjuntoItem();
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [showConjuntoItem, setShowConjuntoItem] = useState(false);
    const [conjuntoItemEmEdicao, setConjuntoItemEmEdicao] = useState(null);
    const { showMessage } = useMessage();
    const { showYesNo } = useYesNo();
    const [novoReg, setNovoReg] = useState(false);

    useEffect(() => {
        if (show){
            handleNovo();
        }            
    }, [show]);

    const handleNovo = () => {
        setConjunto(new Conjunto());
        fetchConjuntoItens(0);
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage("Selecione um Conjunto para editar!");                        
            return;
        }
        setNovoReg(false);
    };

    const handleDelete = async (e) => {
        e.preventDefault();
        if (!conjunto?.id) {
            showMessage("Selecione um Conjunto para excluir!");            
        } else {
            const resposta = await showYesNo("Deseja excluir o conjunto selecionado?");
            if (resposta) {
                await deleteConjunto(conjunto.id);
                handleNovo();
            }
        }
    };

    const handleSave = async () => {
        try {
            if (!conjunto.nome) {
                showMessage("Informe um nome para o conjunto!");                
                return;
            }

            if (!conjunto.id) {
                await addConjunto(conjunto);
            } else {
                await updateConjunto(conjunto);
            }
            handleNovo();
        } catch (error) {
            console.error("Erro ao gravar dados: ", error);
        }
    };

    const handleExit = () => {
        const conjuntoSel = conjuntos.find(c => c.id.toString() === conjunto?.id?.toString());

        if (conjuntoSel) {
            setConjunto(conjuntoSel);
            handleEditar(conjunto?.id);
        } else {
            setConjunto(new Conjunto());
        }

    };

    const handleSelectConjunto = (conjuntoSel) => {
        if (!conjuntoSel) {
            setConjunto(new Conjunto());
            setShowSearchModal(false);
            return;
        }
        setConjunto(conjuntoSel);
        setShowSearchModal(false);
        handleEditar(conjuntoSel.id);
    };

    //Testar
    useEffect(() => {        
        fetchConjuntoItens(conjunto?.id);        
    }, [conjunto?.id]);

    // const handleBuscarProduto = async () => {
    //     const produtoSel = await showProdutoSearch();

    //     if (produtoSel) {
    //         setConjuntoItem({...conjuntoItem, produtoId: produtoSel.id, produto:produtoSel}); 
    //         //setConjuntoItem({...conjuntoItem, conjuntoId:conjunto.id, produtoId: produtoSel.id, valorAdicional:0});    
    //     }
    // };

    const handleNovoItem = (e) => {
        e.preventDefault();
        if (conjunto?.id) {
            setConjuntoItemEmEdicao(null);
            setShowConjuntoItem(true);
        } else {
            showMessage('Selecione um conjunto!', 'warning');
        }
    };

    const handleEditarItem = (item) => {
        setConjuntoItemEmEdicao({ ...item });
        setShowConjuntoItem(true);
    };

    const handleFecharConjuntoItem = () => {
        setShowConjuntoItem(false);
        setConjuntoItemEmEdicao(null);
    };

    const handleInativarItem = async (item) => {
        const resposta = await showYesNo("Deseja inativar o item?");
        if (resposta) {
            // O endpoint DELETE realiza a exclusão lógica (Inativo = true).
            await deleteConjuntoItem(item.id);
        }
    };

    if (!show) return null;

    return (
        <>
        <ModalContainer show={show} largura='700px' variant="cadastro" onHide={onHide}>
            <ModalHeader title={novoReg ? 'Novo Conjunto' : 'Alterar Conjunto'} onHide={onHide} />
            <ModalBody>
                <form>
                    <div className="input-group" style={{marginBottom:'10px', alignItems:'end'}}>
                        <Input
                            label="Código"
                            value={conjunto.id || ''}
                            onChange={(e) => setConjunto({ ...conjunto, id: e.target.value })}
                            onBlur={handleExit}
                            disabled={!novoReg}
                            btnBuscar={() => setShowSearchModal(true)}
                        />
                        <Input
                            label="Nome do Conjunto"
                            value={conjunto.nome || ''}
                            onChange={(e) => setConjunto({ ...conjunto, nome: e.target.value })}
                            size={300}
                            autoFocus={true}
                        />
                        <Input
                            label="Qtde Min"
                            value={conjunto.qtdMin || ''}
                            onChange={(e) => setConjunto({ ...conjunto, qtdMin: e.target.value })}
                            size={80}                            
                        />
                        <Input
                            label="Qtde Max"
                            value={conjunto.qtdMax || ''}
                            onChange={(e) => setConjunto({ ...conjunto, qtdMax: e.target.value })}
                            size={80}                            
                        />
                        <InputCheck
                            label="Mostra Ingredientes"
                            checked={conjunto.mostraIngredientes}
                            onChange={(e) => setConjunto({ ...conjunto, mostraIngredientes: e.target.checked })}   
                        />
                        <InputCheck
                            label="Obriga Selecionar Itens"
                            checked={conjunto.obrigaSel}
                            onChange={(e) => setConjunto({ ...conjunto, obrigaSel: e.target.checked })}   
                        />
                        <InputCheck
                            label="Usa Fração"
                            checked={!!conjunto.usarFracao}
                            onChange={(e) => setConjunto({ ...conjunto, usarFracao: e.target.checked })}   
                        />
                        <InputCheck
                            label="Conjunto gera quantidade"
                            checked={!!conjunto.conjuntoGeraQtd}
                            onChange={(e) => setConjunto({ ...conjunto, conjuntoGeraQtd: e.target.checked })}
                        />
                        <InputCheck
                            label="Conjunto define valor do item"
                            checked={!!conjunto.defineValorItem}
                            onChange={(e) => setConjunto({ ...conjunto, defineValorItem: e.target.checked })}
                        />
                        {conjunto?.id !== 0 && (
                        <div style={{ marginTop: "8px" }}>
                            <button
                            className="btn btn-secondary"                
                            onClick={handleNovoItem}
                            >
                            <IoMdAddCircle />Incluir Item
                            </button>
                        </div>
                        )}
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Descrição</th>
                                    <th>Variação</th>
                                    <th style={{ width: '90px', textAlign: 'right' }}>Adicional</th>
                                    <th style={{ width: '82px', textAlign: 'center' }}>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {conjuntoItens.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.produtoId}</td>
                                        <td>{item.produto?.descricao}</td>     
                                        <td>{item.variacao}</td>                                   
                                        <td style={{ width: '90px', textAlign: 'right' }}>
                                            {item.valorAdicional.toLocaleString('pt-BR', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}
                                        </td>
                                        <td style={{ width: '82px' }}>
                                            <div className="d-flex justify-content-center gap-1">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                                    title="Editar item"
                                                    aria-label="Editar item"
                                                    onClick={() => handleEditarItem(item)}
                                                >
                                                    <FaEdit />
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm d-flex align-items-center justify-content-center"
                                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                                    title="Inativar item"
                                                    aria-label="Inativar item"
                                                    onClick={() => handleInativarItem(item)}
                                                >
                                                    <MdDelete />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                {conjuntoItens.length === 0 && (
                                    <tr>
                                        <td colSpan="3" className="text-center">
                                            Nenhum item cadastrado
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <ModalActions >
                    <ModalActionButton className="btn btn-primary" type="button" onClick={handleSave} action="save">
                        Salvar
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-danger" type="button" onClick={handleDelete} disabled={novoReg} action="delete">
                        Excluir
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-secondary" type="button" onClick={handleNovo} disabled={novoReg} action="new">
                        Novo
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>

            <ConjuntoSearch
                show={showSearchModal}
                onHide={() => setShowSearchModal(false)}
                onSelectConjunto={handleSelectConjunto}
            />
        </ModalContainer>

        <ConjuntoItemCad
            isOpen={showConjuntoItem}
            onClose={handleFecharConjuntoItem}
            conjuntoId={conjunto?.id || 0}
            item={conjuntoItemEmEdicao}
        />

        </>
    );
};

export default ConjuntoCad;
